import { REQUEST } from '../../../utils/actionGenerator';
import { fork, take } from 'redux-saga/effects';
import * as api from '../../../utils/api';
import { fetchEntity } from '../../../store/saga';
import * as thirdPartyActions from './actions';

export function* getThirdPartyList() {
  const request = api.getThirdPartyListRequest.bind();
  yield fetchEntity(request, thirdPartyActions.getThirdPartyList, null);
}

export function* createAccount(payload) {
  const request = api.createAccountRequest.bind(null, payload);
  yield fetchEntity(request, thirdPartyActions.createAccount, payload);
}

export function* editAccount(payload) {
  const request = api.editAccountRequest.bind(null, payload);
  yield fetchEntity(request, thirdPartyActions.editAccount, payload);
}

export function* disableEdit(payload) {
  const request = api.disableEditRequest.bind(null, payload);
  yield fetchEntity(request, thirdPartyActions.disableEdit, payload);
}

export function* verifyThirdPartyAccountOtp(payload) {
  const request = api.verifyExpenseOtpRequest.bind(null, payload);
  yield fetchEntity(request, thirdPartyActions.verifyThirdPartyAccountOtp, payload);
}

export function* resendThirdPartyAccountOtp(payload) {
  const request = api.resendExpenseOtpRequest.bind(null, payload);
  yield fetchEntity(request, thirdPartyActions.resendThirdPartyAccountOtp, payload);
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* watchGetThirdPartyListSaga() {
  while (true) {
    yield take(thirdPartyActions.GET_THIRD_PARTY_LIST[REQUEST]);
    yield fork(getThirdPartyList);
  }
}

export function* watchCreateAccountSaga() {
  while (true) {
    const { payload } = yield take(thirdPartyActions.CREATE_ACCOUNT[REQUEST]);
    yield fork(createAccount, payload);
  }
}

export function* watchEditAccountSaga() {
  while (true) {
    const { payload } = yield take(thirdPartyActions.EDIT_ACCOUNT[REQUEST]);
    yield fork(editAccount, payload);
  }
}

export function* watchDisableEditSaga() {
  while (true) {
    const { payload } = yield take(thirdPartyActions.DISABLE_EDIT[REQUEST]);
    yield fork(disableEdit, payload);
  }
}

export function* watchVerifyThirdPartyAccountOtpSaga() {
  while (true) {
    const { payload } = yield take(thirdPartyActions.VERIFY_THIRD_PARTY_ACCOUNT_OTP[REQUEST]);
    yield fork(verifyThirdPartyAccountOtp, payload);
  }
}

export function* watchResendThirdPartyAccountOtpSaga() {
  while (true) {
    const { payload } = yield take(thirdPartyActions.RESEND_THIRD_PARTY_ACCOUNT_OTP[REQUEST]);
    yield fork(resendThirdPartyAccountOtp, payload);
  }
}
